module.exports = __webpack_public_path__ + "img/whatsapp.1c472081.svg";